// Normalize the hidden SSN value in preparation to put it in the store.
// Takes the previous value (unmasked) and the value that was just input (old characters are masked, new characters are unmasked)
// and combines them into a whole unmasked value to be stored in redux.
const normalizeSsnHidden = (value, previousValue) => {
	// remove anything that's not a digit or a dot
	const valueNoDashes = value ? value.substr(0, 11).replace(/[^\d\u25CF]/g, '') : '';
	// remove anything that's not numeric
	const valueNumsOnly = valueNoDashes.replace(/\D/g, '');

	// Find the length (n) of the value with dashes removed, then take the first n characters of the previous value
	// (this accounts for users erasing characters).
	// Then concatenate valueNumsOnly onto the end (this adds on any new characters the user typed in).
	// "valueNumsOnly.substr(...)" tries to make it so that the new characters don't bring the value past the limit (11 including dashes).
	return previousValue
		? previousValue.substring(0, valueNoDashes.length) +
				valueNumsOnly.substr(0, valueNoDashes.length - previousValue.length)
		: valueNumsOnly;
};

export default normalizeSsnHidden;
